import { useCallback } from "react";
import { StyledReactFlow } from "./index.styled";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import { setEdges, setNodes } from "@lib/redux/slices/messageBot";
import {
  Background,
  BackgroundVariant,
  Controls,
  NodeChange,
  EdgeChange,
  Connection,
} from "@xyflow/react";
import FloatingConnectionLine from "./utils/FloatingConnectionLine";
import CustomMenu from "./customMenu";
import Edges from "./edges";
import Nodes from "./nodes";
import AddNodeModal from "./addNodeModal";

function MessageBotTreeCanvas() {
  const dispatch = useTypedDispatch();
  const isDark = useTypedSelector((state) => state.settings.isDark);
  const { nodes, edges } = useTypedSelector((state) => state.messageBot);

  const handleOnNodesChange = useCallback((changes: NodeChange[]) => {
    // console.log("🚀 ~ handleOnNodesChange ~ changes:", changes);
    dispatch(setNodes(changes));
  }, []);

  const handleOnEdgesChange = useCallback((changes: EdgeChange[]) => {
    // console.log("🚀 ~ handleOnEdgesChange ~ changes:", changes);
    dispatch(setEdges(changes));
  }, []);

  const handleOnConnect = useCallback((_connection: Connection) => {
    // console.log("🚀 ~ handleOnConnect ~ connection:", _connection);
  }, []);

  return (
    <StyledReactFlow
      colorMode={isDark ? "dark" : "light"}
      className="message-bot-tree-canvas"
      nodes={nodes}
      edges={edges}
      onNodesChange={handleOnNodesChange}
      onEdgesChange={handleOnEdgesChange}
      onConnect={handleOnConnect}
      edgeTypes={Edges}
      nodeTypes={Nodes}
      fitView
      minZoom={0.2}
      maxZoom={1.5}
      connectionLineComponent={FloatingConnectionLine}
    >
      <Background variant={BackgroundVariant.Dots} />
      {/* <MiniMap /> */}
      <Controls />
      <CustomMenu />
      <AddNodeModal />
    </StyledReactFlow>
  );
}

export default MessageBotTreeCanvas;
